import { ReactElement, useMemo, useState } from 'react';
import { WaterOverviewInfo } from 'providers/types/api-private';
import { WaterGraph } from './components/Graph';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';
import { CardsGraphContainer, DetailsButton, WaterCardContainer } from '../styles';
import { TitleGraph } from '~/pages/NewOverview/styles';
import { useFilterContext } from '~/pages/NewOverview/contexts/FilterContext';
import { handleFilterStateRoute } from '~/pages/NewOverview/helpers/filters';

const WATER_DASHBOARD_CLIENT_IDS = new Set([152]);

interface WaterCardContentProps {
  data: WaterOverviewInfo | undefined;
  expanded: boolean;
}

export function WaterCardContent({
  data,
  expanded,
}: Readonly<WaterCardContentProps>): ReactElement {
  const [profile] = useState(getUserProfile);
  const { t } = useTranslation();
  const { selectedOptions, clients } = useFilterContext();
  const history = useHistory();

  const hasWaterDashboard = useMemo(
    () => profile.permissions.PER_CLIENT.some((item) => WATER_DASHBOARD_CLIENT_IDS.has(item.clientId)),
    [profile.permissions.PER_CLIENT],
  );

  function onClickDetails(): void {
    if (hasWaterDashboard) {
      history.push('/analise/agua');
      return;
    }
    history.push('/analise/utilitarios?dispositivo=agua',
      handleFilterStateRoute(clients, selectedOptions, profile));
  }

  return (
    <WaterCardContainer expanded={expanded}>
      <TitleGraph>{t('consumoAgua')}</TitleGraph>
      <CardsGraphContainer>
        <WaterGraph data={data} expanded={expanded} />
        {data && (
          <DetailsButton
            type="button"
            variant="primary-ghost"
            onClick={onClickDetails}
          >
            {t('verDetalhes')}
          </DetailsButton>
        )}
      </CardsGraphContainer>
    </WaterCardContainer>
  );
}
